export default __webpack_public_path__ + "static/media/ba-photo.5dbc1905.jpg";